import { useEffect } from 'react';

export function useOnClickOutside<T extends Node, CbT extends (event: Event) => void, Z extends Node>(
  ref: T | null,
  cb: CbT,
  excludeNode: Z | null,
): void {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (
        !ref ||
        ref?.contains?.(event.target as Node) ||
        (excludeNode && excludeNode.contains(event.target as Node))
      ) {
        return;
      }
      cb(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, cb, excludeNode]);
}
